import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUser from '../../../../hook/data/useUser';
import { useIFrameModal } from '../../../../hook/modal/useIFrameModal';
import { Period } from '../../../../model/enum/enums';
import { GetRazorSiteUrl } from '../../../../utils/URLUtils';
import Charts from '../Charts/Charts';
import styles from './ProgressContent.module.scss';

interface ProgressContentProps {
    chartSize?: { Daily?: number, Weekly?: number, Monthly?: number };
}


const ProgressContent = ({ chartSize }: ProgressContentProps) => {
    const { t } = useTranslation();
    const [period, setPeriod] = useState(Period.Daily);

    const { open } = useIFrameModal();
    const { userInfo } = useUser();


    return (
        <div className={styles.progressContent}>
            <div className={styles.periodSelectorContainer}>
                <div className={styles.periodSelector}>
                    <span onClick={() => setPeriod(Period.Daily)} className={styles.goalText + ' ' + (period === Period.Daily ? styles.active : '')}>{t('Daily')}</span>
                    <span onClick={() => setPeriod(Period.Weekly)} className={styles.goalText + ' ' + (period === Period.Weekly ? styles.active : '')}>{t('Weekly')}</span>
                    <span onClick={() => setPeriod(Period.Monthly)} className={styles.goalText + ' ' + (period === Period.Monthly ? styles.active : '')}>{t('Monthly')}</span>
                </div>
                <span className={styles.goalText + ' ' + styles.active}
                    onClick={() => open(GetRazorSiteUrl('onboarding/daily-goal', userInfo?.Token, 'embedded=true'), t('Commit to a daily goal'))}>
                    {t(`${userInfo?.GoalMinsPerDay} mins/day`)}
                </span>
            </div>
            <Charts period={period} chartSize={chartSize} />
        </div>
    );
};

export default ProgressContent;